// Проверка email: любая последовательность символов без пробелов
// и @, затем @, домен с точкой и доменная зона, например: user@mail.ru
const EMAIL_REGEX: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MIN_PASSWORD_LENGTH: number = 4; // TODO: заменить на 6 после интеграции с бэком

export interface IAuthData {
    email: string;
    password?: string;
}

export interface ILoginData extends IAuthData {
    password: string;
}

export interface IResetPasswordData extends IAuthData {
    password?: never;
}

export const validateAuthForm = (data: IAuthData): boolean => {
  const isEmailValid: boolean = EMAIL_REGEX.test(data.email);

  if (data.password !== undefined) {
    const isPasswordValid: boolean = data.password.length >= MIN_PASSWORD_LENGTH;

    return isEmailValid && isPasswordValid;
  }

  return isEmailValid;
};

export const validateLogin = (data: ILoginData): boolean => validateAuthForm(data);

export const validateResetPassword = (data: IResetPasswordData): boolean => validateAuthForm(data);
